// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as React$1 from "@sentry/react";
import * as Browser from "@sentry/browser";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let ErrorBoundary = {};

function initiateSentry(dsn) {
  try {
    let browserClient = new Browser.BrowserClient({
      dsn: dsn,
      environment: isProductionEnv ? "production" : "development",
      transport: Browser.makeFetchTransport,
      stackParser: Browser.defaultStackParser,
      integrations: [
        React$1.browserTracingIntegration(),
        React$1.reactRouterV6BrowserTracingIntegration({
          useEffect: prim => {
            React.useEffect(prim, []);
          }
        }),
        React$1.replayIntegration()
      ],
      tracesSampleRate: 0.1,
      tracePropagationTargets: [
        "localhost",
        backendEndPoint,
        sdkUrl
      ],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
    Browser.getCurrentScope().setClient(browserClient);
    browserClient.init();
    return;
  } catch (raw_err) {
    let err = Primitive_exceptions.internalToException(raw_err);
    console.error(err);
    return;
  }
}

function initiateSentryJs(dsn) {
  try {
    let browserClient = new Browser.BrowserClient({
      dsn: dsn,
      environment: isProductionEnv ? "production" : "development",
      transport: Browser.makeFetchTransport,
      stackParser: Browser.defaultStackParser,
      integrations: [
        React$1.browserTracingIntegration(),
        React$1.replayIntegration()
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ["localhost"],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0
    });
    Browser.getCurrentScope().setClient(browserClient);
    browserClient.init();
    return;
  } catch (raw_err) {
    let err = Primitive_exceptions.internalToException(raw_err);
    console.error(err);
    return;
  }
}

function captureException(err) {
  if (err === undefined) {
    return;
  }
  let e = Primitive_option.valFromOption(err);
  e.tag = "HyperTag";
  React$1.captureException(e);
}

function sentryLogger(callback) {
  try {
    return callback();
  } catch (raw_err) {
    return captureException(Primitive_exceptions.internalToException(raw_err));
  }
}

export {
  ErrorBoundary,
  initiateSentry,
  initiateSentryJs,
  captureException,
  sentryLogger,
}
/* react Not a pure module */
